var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4303 1.68358C10.297 1.60296 10.1268 1.69893 10.1268 1.85471V4.05685C10.1268 4.21263 9.95655 4.30861 9.82326 4.22798L5.6169 1.68359C5.48361 1.60297 5.31339 1.69894 5.31339 1.85472V4.05685C5.31339 4.21263 5.14317 4.30861 5.00987 4.22798L0.803514 1.68359C0.670222 1.60297 0.5 1.69894 0.5 1.85472V14.3C0.5 14.4105 0.589543 14.5 0.7 14.5H5.31339H5.87322H10.1268H10.6866H15.3C15.4105 14.5 15.5 14.4105 15.5 14.3V4.86278C15.5 4.79278 15.4634 4.72788 15.4035 4.69165L10.4303 1.68358ZM6.52968 9.87331C6.52968 9.98377 6.44014 10.0733 6.32968 10.0733H4.7297C4.61924 10.0733 4.5297 9.98377 4.5297 9.87331V8.2C4.5297 8.08954 4.61924 8 4.7297 8H6.32968C6.44014 8 6.52968 8.08954 6.52968 8.2V9.87331ZM11.4703 9.87331C11.4703 9.98377 11.3808 10.0733 11.2703 10.0733H9.67032C9.55987 10.0733 9.47032 9.98377 9.47032 9.87331V8.2C9.47032 8.08954 9.55987 8 9.67032 8H11.2703C11.3808 8 11.4703 8.08954 11.4703 8.2V9.87331Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkshop);
export default __webpack_public_path__ + "static/media/icon-workshop.e823847d55de2591932f6dfa10ca493b.svg";
export { ForwardRef as ReactComponent };